import React, { useState } from 'react';
import './PartnerDashboard.css';

const PartnerDashboard = () => {
  const [stats, setStats] = useState({
    totalBookings: 156,
    monthlyRevenue: 45000,
    averageRating: 4.8,
    activeExperiences: 12
  });

  const [bookings] = useState([
    {
      id: 'BK001',
      title: 'Bali Spiritual Retreat',
      guest: 'John D.',
      date: 'Dec 15, 2024',
      amount: 2500,
      status: 'confirmed'
    },
    {
      id: 'BK002',
      title: 'Costa Rica Adventure',
      guest: 'Sarah M.',
      date: 'Dec 18, 2024',
      amount: 3200,
      status: 'pending'
    },
    {
      id: 'BK003',
      title: 'Japan Cultural Tour',
      guest: 'Michael K.',
      date: 'Dec 20, 2024',
      amount: 2800,
      status: 'confirmed'
    },
    {
      id: 'BK004',
      title: 'Iceland Northern Lights',
      guest: 'Emma L.',
      date: 'Dec 22, 2024',
      amount: 3500,
      status: 'pending'
    }
  ]);

  const refreshDashboard = () => {
    setStats({
      totalBookings: Math.floor(Math.random() * 200) + 100,
      monthlyRevenue: Math.floor(Math.random() * 60000) + 30000,
      averageRating: (Math.random() * 0.5 + 4.5).toFixed(1),
      activeExperiences: Math.floor(Math.random() * 15) + 8
    });
  };

  const exportData = () => {
    alert('Export functionality would generate CSV/PDF report');
  };

  return (
    <div className="dashboard">
      <div className="header">
        <h1>Partner Dashboard</h1>
        <p>Real-time booking and revenue management</p>
      </div>

      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-value">{stats.totalBookings}</div>
          <div className="stat-label">Total Bookings</div>
        </div>
        <div className="stat-card">
          <div className="stat-value">${stats.monthlyRevenue.toLocaleString()}</div>
          <div className="stat-label">Monthly Revenue</div>
        </div>
        <div className="stat-card">
          <div className="stat-value">{stats.averageRating}</div>
          <div className="stat-label">Average Rating</div>
        </div>
        <div className="stat-card">
          <div className="stat-value">{stats.activeExperiences}</div>
          <div className="stat-label">Active Experiences</div>
        </div>
      </div>

      <div className="bookings-table">
        <div className="table-header">Recent Bookings</div>
        <div id="bookingsList">
          {bookings.map(booking => (
            <div key={booking.id} className="booking-row">
              <div>
                <strong>{booking.id}</strong>
                <br />
                {booking.title}
              </div>
              <div>{booking.guest}</div>
              <div>{booking.date}</div>
              <div>${booking.amount.toLocaleString()}</div>
              <div>
                <span className={`status ${booking.status}`}>
                  {booking.status.charAt(0).toUpperCase() + booking.status.slice(1)}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div style={{ marginTop: '30px', textAlign: 'center' }}>
        <button className="btn btn-primary" onClick={refreshDashboard}>
          Refresh Data
        </button>
        <button className="btn btn-success" onClick={exportData}>
          Export Report
        </button>
      </div>
    </div>
  );
};

export default PartnerDashboard;
